import { createStructuredSelector} from 'reselect';
import { selectAccountID, selectNavBarData } from '../../../selectors/globalSelectors';
import { selectAccountRole } from '../../Messaging/selectors';

const getAccountSummaryStates = (data) => data.accountSummary;

const getMyAccountData = (data) => {
    const { myAccount_data } = getAccountSummaryStates(data);
    return myAccount_data.data
}

const getSelectedHeader = (data) => {
    const { selectedHeader } = getAccountSummaryStates(data);
    return selectedHeader
}

const getIsInvestmentLoading = (data) => {
    const { investmentData } = getAccountSummaryStates(data);
    return investmentData.isLoading
}

const getInvestmentData = (data) => {
    const { investmentData } = getAccountSummaryStates(data);
    return investmentData.data
}

const getIsGrantLoading = (data) => {
    const { grant_data } = getAccountSummaryStates(data);
    return grant_data.isLoading
}

const getGrant_data = (data) => {
    const { grant_data } = getAccountSummaryStates(data);
    return grant_data.data
}

const getIsContributionLoading = (data) => {
    const { contribution } = getAccountSummaryStates(data);
    return contribution.isLoading
}
const getContribution = (data) => {
    const { contribution } = getAccountSummaryStates(data);
    return contribution.data
}

const getIsOtherTransactionLoading = (data) => {
    const { otherTransaction_data } = getAccountSummaryStates(data);
    return otherTransaction_data.isLoading
}
const getOtherTransaction_data = (data) => {
    const { otherTransaction_data } = getAccountSummaryStates(data);
    return otherTransaction_data.data
}

const getIsAccountLoading = (data) => {
    const { account_data } = getAccountSummaryStates(data);
    return account_data.isLoading
}
const getAccount_data = (data) => {
    const { account_data } = getAccountSummaryStates(data);
    return account_data.data
}



const getIsAccountSummaryLoading = (data) => {
    const { accountSummaryBalance_data } = getAccountSummaryStates(data);
    return accountSummaryBalance_data.isLoadingBot
}
const getAccountSummaryBalance_data = (data) => {
    const { accountSummaryBalance_data } = getAccountSummaryStates(data);
    return accountSummaryBalance_data.data
}


const getIsAllAccountSummaryLoading = (data) => {
    const { accountSummaryBalance_data_all } = getAccountSummaryStates(data);
    return accountSummaryBalance_data_all.isLoadingBot
}
const getAccountSummaryBalance_data_all = (data) => {
    const { accountSummaryBalance_data_all } = getAccountSummaryStates(data);
    return accountSummaryBalance_data_all.data
}


const getBotStatusText = (data) => {
    const { accountSummaryBalance_data } = getAccountSummaryStates(data);
    return accountSummaryBalance_data.botStatusText
}



// Account summary
export const accountSummaryDerivedStates = createStructuredSelector({
    myAccount_data: getMyAccountData,
    selected: getSelectedHeader,
    accountID: selectAccountID,
    isInvestmentLoading: getIsInvestmentLoading,
    investmentData: getInvestmentData,
    isGrantLoading: getIsGrantLoading ,
    grant_data:getGrant_data,
    isContributionLoading: getIsContributionLoading, 
    contribution: getContribution,
    isAccountSummaryLoading: getIsAccountSummaryLoading,
    accountSummaryBalance_data: getAccountSummaryBalance_data,
    isAllAccountSummaryLoading:getIsAllAccountSummaryLoading ,
    accountSummaryBalance_data_all :getAccountSummaryBalance_data_all,
    botStatusText: getBotStatusText,
    isAccountLoading:getIsAccountLoading,
    account_data:getAccount_data,
    isOtherTransactionLoading: getIsOtherTransactionLoading ,
    otherTransaction_data: getOtherTransaction_data,
    AdditionalAccountDetails: selectAccountRole,
    navBarData: selectNavBarData,
});
